import type { SavedCoilConfiguration } from "../../../web-app";
import {
  HYDRATE_CONFIGURATIONS,
  SET_CONFIG_PAGE,
  SET_CONFIG_SEARCH,
  SET_CONFIG_STATUS_FILTER,
  SET_CONFIG_VIEW,
  SET_SELECTED_CONFIG_ID,
  OPEN_CONFIG_DETAIL,
  CLOSE_CONFIG_DETAIL,
  UPSERT_CONFIGURATION,
  DELETE_CONFIGURATION,
} from "../types";

export type ConfigView = "list" | "detail";

export interface ConfigurationsState {
  items: SavedCoilConfiguration[];
  search: string;
  statusFilter: string[];
  page: number;
  selectedId: string | null;
  view: ConfigView;
}

const initialState: ConfigurationsState = {
  items: [],
  search: "",
  statusFilter: ["recommended", "marginal", "not supported"],
  page: 1,
  selectedId: null,
  view: "list",
};

type ConfigurationsAction =
  | { type: typeof HYDRATE_CONFIGURATIONS; items: SavedCoilConfiguration[] }
  | { type: typeof SET_CONFIG_SEARCH; search: string }
  | { type: typeof SET_CONFIG_STATUS_FILTER; statusFilter: string[] }
  | { type: typeof SET_CONFIG_PAGE; page: number }
  | { type: typeof SET_SELECTED_CONFIG_ID; selectedId: string | null }
  | { type: typeof SET_CONFIG_VIEW; view: ConfigView }
  | { type: typeof OPEN_CONFIG_DETAIL; id: string }
  | { type: typeof CLOSE_CONFIG_DETAIL }
  | { type: typeof UPSERT_CONFIGURATION; config: SavedCoilConfiguration }
  | { type: typeof DELETE_CONFIGURATION; id: string };

const configurationsReducer = (
  state = initialState,
  action: ConfigurationsAction,
): ConfigurationsState => {
  switch (action.type) {
    case HYDRATE_CONFIGURATIONS:
      return { ...state, items: action.items };
    case SET_CONFIG_SEARCH:
      return { ...state, search: action.search, page: 1 };
    case SET_CONFIG_STATUS_FILTER:
      return { ...state, statusFilter: action.statusFilter, page: 1 };
    case SET_CONFIG_PAGE:
      return { ...state, page: action.page };
    case SET_SELECTED_CONFIG_ID:
      return { ...state, selectedId: action.selectedId };
    case SET_CONFIG_VIEW:
      return { ...state, view: action.view };
    case OPEN_CONFIG_DETAIL:
      return { ...state, selectedId: action.id, view: "detail" };
    case CLOSE_CONFIG_DETAIL:
      return { ...state, selectedId: null, view: "list" };
    case UPSERT_CONFIGURATION: {
      const index = state.items.findIndex((item) => item.id === action.config.id);
      if (index === -1) {
        return { ...state, items: [...state.items, action.config] };
      }
      const items = [...state.items];
      items[index] = action.config;
      return { ...state, items };
    }
    case DELETE_CONFIGURATION: {
      const items = state.items.filter((item) => item.id !== action.id);
      const removedSelected = state.selectedId === action.id;
      return {
        ...state,
        items,
        selectedId: removedSelected ? null : state.selectedId,
        view: removedSelected ? "list" : state.view,
      };
    }
    default:
      return state;
  }
};

export default configurationsReducer;
